import { render, staticRenderFns } from "./BookingClientPhoneNumber.vue?vue&type=template&id=1ba9c71a&"
import script from "./BookingClientPhoneNumber.vue?vue&type=script&lang=ts&"
export * from "./BookingClientPhoneNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports